import axios from 'axios';
import { Enterprise } from '../entity/entity.types';
import { EnterprisePopoverInfos } from './popover/enterprisePopover.types';
import { EnterpriseDecisions, LawFirm, Lawyer } from './enterprise.types';

export async function fetchEnterpriseDecisions(
  siren: string,
): Promise<EnterpriseDecisions> {
  return (
    await axios.get('/getEnterpriseDecisions', {
      params: {
        siren,
      },
    })
  ).data;
}

export type CaseDataType = {
  caseData: {
    years: number[];
    caseCounts: number[];
  };
};

export function fetchEnterpriseCaseCountForSearchSnippet(
  siren: string,
): Promise<{ data: CaseDataType }> {
  return axios.get('/getEnterpriseCaseCountForSearchSnippet', {
    params: {
      siren,
    },
  });
}

export async function fetchEntrepriseLawFirms(
  siren: string,
  full: boolean = false,
): Promise<{ lawFirms: Array<LawFirm>; hasMore: boolean }> {
  return (
    await axios.get('/getEnterpriseLawFirms', {
      params: {
        siren,
        full,
      },
    })
  ).data;
}

export async function fetchEntrepriseLawyers(
  siren: string,
  full: boolean = false,
): Promise<{ lawyers: Array<Lawyer>; hasMore: boolean }> {
  return (
    await axios.get('/getEnterpriseLawyers', {
      params: {
        siren,
        full,
      },
    })
  ).data;
}

export async function fetchEntrepriseOpponents(
  siren: string,
  full: boolean = false,
): Promise<{
  oppositeEnterprises: Array<Enterprise>;
  hasMore: boolean;
}> {
  return (
    await axios.get('/getOppositeEnterprises', {
      params: {
        siren,
        full,
      },
    })
  ).data;
}

export function fetchEnterpriseInfos(
  siren: string,
): Promise<{ data: EnterprisePopoverInfos }> {
  return axios.get('/getEnterprisePopover', {
    params: {
      siren,
    },
  });
}
